import { Link } from "react-router-dom";
import { LOGO_URL } from "@/lib/flow";
import SocialIcons from "@/components/site/SocialIcons";

export default function Footer() {
    return (
        <footer
            className="border-t border-flow-line bg-white mt-24"
            data-testid="site-footer"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 grid grid-cols-1 md:grid-cols-4 gap-12">
                <div>
                    <div className="flex items-center gap-3">
                        <img src={LOGO_URL} alt="FlowLux" className="h-10 w-10 object-contain" />
                        <div>
                            <div className="text-flow-blue text-lg tracking-[0.18em]" style={{ fontWeight: 300 }}>
                                FLOWLUX
                            </div>
                            <div className="text-[10px] tracking-[0.28em] text-flow-muted uppercase">
                                Smart Toilets · South Florida
                            </div>
                        </div>
                    </div>
                    <p className="mt-6 max-w-md text-sm text-flow-muted leading-relaxed">
                        South Florida&apos;s premier smart bathroom experience, delivered and installed with white-glove service
                    </p>
                </div>

                <div>
                    <div className="fl-eyebrow mb-4">Explore</div>
                    <ul className="space-y-3 text-sm">
                        <li><Link to="/products" className="fl-link" data-testid="footer-link-catalog">Catalog</Link></li>
                        <li><Link to="/quote" className="fl-link" data-testid="footer-link-quote">Contact</Link></li>
                        <li><Link to="/book" className="fl-link" data-testid="footer-link-book">Book Installation</Link></li>
                        <li><Link to="/terms" className="fl-link" data-testid="footer-link-terms">Terms & Conditions</Link></li>
                        <li><Link to="/policy" className="fl-link" data-testid="footer-link-policy">Policy</Link></li>
                    </ul>
                </div>

                <div>
                    <div className="fl-eyebrow mb-4">Service Areas</div>
                    <ul className="space-y-3 text-sm">
                        <li><Link to="/locations/miami" className="fl-link" data-testid="footer-link-miami">Smart Toilets Miami</Link></li>
                        <li><Link to="/locations/fort-lauderdale" className="fl-link" data-testid="footer-link-ftl">Smart Toilets Fort Lauderdale</Link></li>
                        <li><Link to="/locations/boca-raton" className="fl-link" data-testid="footer-link-boca">Smart Toilets Boca Raton</Link></li>
                        <li><Link to="/locations/west-palm-beach" className="fl-link" data-testid="footer-link-wpb">Smart Toilets West Palm Beach</Link></li>
                    </ul>
                </div>

                <div>
                    <div className="fl-eyebrow mb-4">Contact</div>
                    <ul className="space-y-3 text-sm text-flow-ink">
                        <li>
                            <a
                                href="mailto:team@flowlux.co"
                                className="fl-link"
                                data-testid="footer-email"
                            >
                                team@flowlux.co
                            </a>
                        </li>
                        <li>
                            <a
                                href="tel:+15613360491"
                                className="fl-link"
                                data-testid="footer-phone"
                            >
                                561-336-0491
                            </a>
                        </li>
                        <li className="text-flow-muted">Serving all of South Florida</li>
                        <li className="text-flow-ink pt-3" data-testid="footer-address">
                            <div>350 Lincoln Rd</div>
                            <div>Miami Beach, FL 33139</div>
                        </li>
                        <li className="pt-2" data-testid="footer-social">
                            <SocialIcons size={16} testIdPrefix="footer-social" />
                        </li>
                    </ul>
                </div>
            </div>

            <div className="border-t border-flow-line">
                <div className="max-w-7xl mx-auto px-6 md:px-10 py-10" data-testid="footer-warranty">
                    <div className="fl-eyebrow mb-3">FlowLux Warranty</div>
                    <p className="text-[11px] text-flow-muted leading-relaxed max-w-4xl">
                        FlowLux warrants each product against defects in materials and workmanship for the warranty period specified in the individual product listing, beginning on the date of purchase. In the event of a covered defect or failure, FlowLux will, at its sole discretion, provide a replacement or full refund upon the return of the defective product in its original condition. This warranty is non-transferable, applies to the original purchaser only, and does not cover damage resulting from misuse, improper installation, or unauthorized modification.
                    </p>
                </div>
            </div>

            <div className="border-t border-flow-line">
                <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between text-xs text-flow-muted tracking-wide">
                    <span>© {new Date().getFullYear()} FlowLux. All rights reserved.</span>
                    <span className="tracking-[0.3em] uppercase">Live like a king</span>
                </div>
            </div>
        </footer>
    );
}
